/*
This function filters an object’s properties into three categories:
props, slotted, and hidden based on predefined rules.
This makes it easier to manage and use the properties differently based on their categorization.
*/

import { BaseBlok } from '../blok-to-component/types';
import { AssetData } from '../../utils/asset/types';
import { StringService } from '../../services/string';
import { getMappedProps } from '../../utils/get-mapped-props';

const shouldBePrinted = (value: string | unknown): boolean =>
  !(value === null || value === undefined || value === false);

// !OLD IMPLEMENTATION
// export const filterProps = (blok: BaseBlok): FilteredProps => {
//   const keys = Object.keys(blok).filter((key) => key && key[0] !== '_' && key !== 'component');
//   const slottedKeys = keys.filter((key) => key.startsWith('slotted'));
//   const hiddenKeys = keys.filter((key) => key.startsWith('hidden'));

//   return {
//     props: keys
//       .filter((key) => !slottedKeys.includes(key) && !hiddenKeys.includes(key))
//       .reduce((accumulator, key) => ({
//         ...accumulator,
//         ...(shouldBePrinted(blok[key]) ? getMappedProps(key, blok[key] as AssetData) : {}),
//       }), {}),
//     slotted: slottedKeys.reduce((accumulator, key) => ({
//       ...accumulator,
//       [StringService.snakeToKebab(key === 'slotted' ? 'unnamed' : key.substring('slotted_'.length))]: blok[key],
//     }), {}),
//     hidden: hiddenKeys.reduce((accumulator, key) => ({
//       ...accumulator,
//       [StringService.snakeToKebab(key === 'hidden' ? 'unnamed' : key.substring('hidden_'.length))]: blok[key],
//     }), {}),
//   };
// };

// TODO: NEW IMPLEMENTATION; needs to be tested.
export type FilteredProps = {
  props: Record<string, unknown>;
  slotted: Record<string, unknown>;
  hidden: Record<string, unknown>;
};

export const filterProps = (blok: BaseBlok): FilteredProps => {
  if (!blok) {
    return { props: {}, slotted: {}, hidden: {} };
  }

  return Object.keys(blok).reduce<FilteredProps>(
    (accumulator, key) => {
      const isSlotted = key.startsWith('slotted');
      const isHidden = key.startsWith('hidden');
      const isIgnoredKey = key[0] === '_' || key === 'component';

      if (isIgnoredKey) {
        return accumulator;
      }

      const formattedKey = StringService.snakeToKebab(
        key === 'slotted' || key === 'hidden'
          ? 'unnamed'
          : key.substring(isSlotted || isHidden ? key.indexOf('_') + 1 : 0),
      );

      if (isSlotted) {
        accumulator.slotted[formattedKey] = blok[key];
      } else if (isHidden) {
        accumulator.hidden[formattedKey] = blok[key];
      } else if (shouldBePrinted(blok[key])) {
        accumulator.props = {
          ...accumulator.props,
          ...getMappedProps(key, blok[key] as AssetData),
        };
      }

      return accumulator;
    },
    { props: {}, slotted: {}, hidden: {} },
  );
};
